import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import NavigationBar from './NavigationBar';
import { OPS_NAV, isSuperAdminSession } from './opsNav';
import '../css/OpsLayout.css';

// 운영 관리 화면이 함께 쓰는 틀. 규격: docs/superpowers/specs/2026-09-14-ops-auth-toss.md D3.
//
// 메뉴 항목과 최고관리자 걸림은 opsNav.js 에 있다(순환 import 방지 — NavigationBar.js 도
// 그 파일의 OPS_NAV 를 불러온다). 여기서는 그대로 다시 내보낸다.
export { OPS_NAV, isSuperAdminSession };

export default function OpsLayout({ title, description, actions, sideNav = true, children }) {
    const { pathname } = useLocation();
    const superAdmin = isSuperAdminSession();

    return (
        <>
            {/* ⚠️ 상단 바는 .ops-page 의 바로 앞 형제여야 한다. NavigationBar.css 의
                `.navigation-bar + *` 가 아래 내용의 위 여백을 준다. 사이에 무엇을 끼우지 말 것. */}
            <NavigationBar />
            <div className="ops-page">
                <div className={`ops-page__shell${sideNav ? '' : ' ops-page__shell--bare'}`}>
                    {sideNav && (
                        <nav className="ops-page__side" aria-label="운영 관리">
                            {OPS_NAV.map((group) => {
                                const items = group.items.filter((item) => !item.superAdmin || superAdmin);
                                if (items.length === 0) return null;
                                return (
                                    <div className="ops-page__side-group" key={group.group}>
                                        <span className={`ops-page__side-group-label${group.strong ? ' ops-page__side-group-label--strong' : ''}`}>{group.group}</span>
                                        {items.map((item) => {
                                            const active = pathname === item.to;
                                            return (
                                                <Link
                                                    key={item.to}
                                                    to={item.to}
                                                    className={`ops-page__side-link${active ? ' ops-page__side-link--active' : ''}`}
                                                    aria-current={active ? 'page' : undefined}
                                                >
                                                    {item.label}
                                                    {item.superAdmin && <span className="ops-page__side-badge" aria-hidden="true">최고</span>}
                                                </Link>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                        </nav>
                    )}
                    <main className="ops-page__main">
                        {(title || actions) && (
                            <header className="sds-page-header">
                                <div>
                                    {title && <h1 className="sds-page-header__title">{title}</h1>}
                                    {description && <p className="sds-page-header__sub">{description}</p>}
                                </div>
                                {actions && <div className="sds-page-header__actions">{actions}</div>}
                            </header>
                        )}
                        {children}
                    </main>
                </div>
            </div>
        </>
    );
}
